import { BASE_COLUMN_CONFIG } from "../../baseColumn/BaseColumn_config";
import { ISdColDef } from "../../baseColumn/BaseColumnTypes";

export const MASTER_DETAIL_ROW_COLUMN_CONFIG = (columnOptions?: ISdColDef<any, any>): ISdColDef<any, any> => ({
  ...BASE_COLUMN_CONFIG,
  field: "name",
  headerName: "header Name",
  editable: false,
  ...columnOptions
});
